module.exports = __webpack_public_path__ + "static/King_Sooper_pin-38522d76bf5f89ab67f8347a55bb7c29.png";